export default {"src":"/_next/static/media/business6.d587c2a9.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};